import React, { useEffect, useState } from 'react';
import { showToast } from './Messages';

const DocShare = ({ onClose, userId, userName, companySeq, title }) => {
    const [emailValue, setEmailValue] = useState('');
    const [mailList, setMailList] = useState([]);
    const [userEmailInfo, setUserEmailInfo] = useState([]);
    const [matchedUsers, setMatchedUsers] = useState([]);

    useEffect(() => {
        getUserEmailInfo();
    }, []);

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const splitKorean = (text) => text.normalize('NFD').replace(/[\u314e-\u314f\u1160-\u1161]/g, '');

    const handleKeyUp = () => {
        const trimmedValue = emailValue.trim();
        if (trimmedValue !== '') {
            const matched = userEmailInfo.filter(user => {
                const devUserName = splitKorean(user.devUserName).toLowerCase();
                const devUserId = user.devUserId.toLowerCase();
                const searchValue = splitKorean(trimmedValue).toLowerCase();

                return devUserName.includes(searchValue) || devUserId.includes(searchValue);
            });
            setMatchedUsers(matched.slice(0, 5));
        } else {
            setMatchedUsers([]);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const trimmedValue = emailValue.trim();
            if (!isValidEmail(trimmedValue)) {
                showToast('warning', '유효한 이메일 형식이 아닙니다.');
                return;
            }
            if (!mailList.find(mail => mail.devUserId === trimmedValue)) {
                setMailList([...mailList, { devUserId: trimmedValue, devUserName: '' }]);
                setEmailValue('');
            } else {
                showToast('warning', '이미 추가된 이메일입니다.');
            }
        }
    };

    const addMailList = (user) => {
        if (!mailList.find(mail => mail.devUserId === user.devUserId)) {
            setMailList([...mailList, user]);
        }
        setEmailValue('');
        setMatchedUsers([]);
    };

    const handleDelete = (index) => {
        setMailList(mailList.filter((_, i) => i !== index));
    };

    const handleInputChange = (e) => {
        setEmailValue(e.target.value);
    };

    const sendShareManual = () => {
        if (!userId) return;
        if (mailList.length === 0) {
            showToast('warning', '공유할 메일 주소가 없습니다.');
            return;
        }
        const body = {
            mailList: mailList,
            title: `${userName}님이 공유한 문서가 도착했습니다.`,
            tbodyKey: "문서명",
            tbodyValue: `<a href="${window.location.href}">${title}</a>`
        };
        fetch(`api/Document/SendShareManual`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then(response => response.json())
            .then(resultData => {
                if (resultData.message === 'Success') {
                    onClose(null);
                    showToast('success', '문서 공유 완료');
                } else {
                    showToast('danger', '문서 공유 실패');
                }
            });
    };

    const getUserEmailInfo = async () => {
        const response = await fetch(`api/User/GetUserEmailInfo/${companySeq}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        });
        const result = await response.json();
        setUserEmailInfo(result.data.table);
    };

    return (
        <div className="msg-popup center-box overflow-unset">
            <div className="modal">
                <div className="modal-top">
                    <h3 className="modal-title">문서 메일 공유</h3>
                    <button className="btn-close" onClick={() => onClose(null)}>
                        <i className="icoKdc32 close"></i>
                    </button>
                </div>
                <div className="modal-cnts">
                    <form className="search-input" onKeyUp={handleKeyUp} onKeyDown={handleKeyDown}>
                        <i className="icoKdc20 add-g"></i>
                        <input
                            placeholder="공유할 메일 주소를 입력하고 엔터를 누르세요."
                            value={emailValue}
                            onChange={handleInputChange}
                        />
                    </form>
                    {matchedUsers.length > 0 && (
                        <div className="matched-users">
                            {/* <p className="mail-list-label">검색된 사용자</p> */}
                            <ul className="user-list">
                                {matchedUsers.map((user, index) => (
                                    <li key={index} onClick={() => addMailList(user)}>
                                        {`${user.devUserName} (${user.companyName || user.companyName}) <${user.devUserId}>`}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <div className="mail-list-wrap">
                        <p className="mail-list-label">받는 사람</p>
                        <ul className="mail-list">
                            {mailList.map((email, index) => (
                                <li key={index}>
                                    <p className="mail-address">
                                        {email.devUserName || email.devUserId}
                                    </p>
                                    <button className="btn-delete" onClick={() => handleDelete(index)}>
                                        <i className="icoKdc12 delete"></i>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="mail-list-btm">
                    <button className="btn-share" onClick={sendShareManual}>
                        공유하기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DocShare;